import React, { useEffect, useRef, useState } from "react"

import { useNavScrollHide } from "gpages/hooks/common"
import classNames from "gpages/utils/classnames"

import * as styles from "./nav.module.scss"

import { GCORESAPP, TAOBAO, TIANMAO } from "@data/icons"
import { useAppContext } from "@src/context/appContext"
import { parseCollections } from "@src/utils/data-query"
import { graphql, Link, useStaticQuery } from "gatsby"
import Clickable from "../clickable"
import Container from "../container"
import IconsClickable from "../footer/icons"
import { SIcon } from "../iconSymbols"
import classnames from "gpages/utils/classnames"

const ONLINE_BUY = [TAOBAO, TIANMAO]

const ITEMS = [
  {
    title: "ARCHIVE",
    to: "/archive",
  },
  {
    title: "NEWS",
    to: "/news",
  },
  {
    title: "关于",
    to: "/about",
  },
]

const CenterNav = ({ isTop, onLogoHover }) => {
  return (
    <Container className={classNames(styles.center)}>
      <Link
        to="/"
        className={styles.logo}
        {...(isTop
          ? {
              onMouseEnter: () => {
                onLogoHover?.(true)
              },
            }
          : {})}
      >
        <SIcon name="gi_i_logo" />
      </Link>
      <div className={styles.right}>
        {ITEMS.map(({ to, title }) => {
          return (
            <Link
              key={to}
              to={to}
              {...(isTop
                ? {
                    onMouseEnter: () => {
                      onLogoHover?.(true)
                    },
                  }
                : {})}
            >
              {title}
            </Link>
          )
        })}
      </div>
    </Container>
  )
}

const DesktopNav = () => {
  const [logoHovered, setLogoHovered] = useState(false)
  const visible = useNavScrollHide(800, [false, true])
  const navStaticRef = useRef()
  const navStaticContentRef = useRef()
  const data = useStaticQuery(query)
  const series = data.allSeriesJson?.edges?.map((x) => x.node)
  const collections = parseCollections(data.allCollectionsJson)

  useEffect(() => {
    const clickEvent = (e) => {
      if (!navStaticRef.current) {
        return
      }

      const t = e.target

      setLogoHovered(false)
      if (!navStaticRef.current.contains(t)) {
        setLogoHovered(false)
        return
      }

      if (t.classList.contains("o_link")) {
        setLogoHovered(false)
      }

      // if (
      //   !Array.prototype.find.call(
      //     t.childNodes,
      //     (x) => x.nodeType === Node.TEXT_NODE
      //   )
      // ) {
      //   setLogoHovered(false)
      //   return
      // }
    }
    window.document.documentElement.addEventListener("click", clickEvent)

    return () => {
      window.document.documentElement.removeEventListener("click", clickEvent)
    }
  }, [])

  const renderDropdown = (visible) => {
    return (
      <div
        className={classnames(styles.dropDownContent, {
          [styles.visible]: visible,
        })}
        ref={navStaticContentRef}
      >
        <Container>
          <div className={styles.dropDownCols}>
            {series.map((s) => {
              return (
                <div key={s.title} className={styles.col}>
                  <h3>{s.title}</h3>
                  {collections
                    .filter((x) => x.series === s.title)
                    .map((c) => {
                      return (
                        <div key={c.id}>
                          <Link
                            to={`/collections/${c.slug}`}
                            className="o_link"
                          >
                            {c.title}
                          </Link>
                        </div>
                      )
                    })}
                </div>
              )
            })}
          </div>
        </Container>
      </div>
    )
  }

  return (
    <>
      {/* 全屏菜单出现后的黑色遮罩 */}
      <div
        className={classnames(styles.dropDownMask, {
          [styles.visible]: logoHovered,
        })}
      />
      {/* 首屏的导航和全屏菜单 */}
      <div
        ref={navStaticRef}
        className={classNames(styles.navStatic, {
          [styles.dropDown]: logoHovered,
        })}
      >
        <CenterNav
          isTop
          onLogoHover={(hovered) => {
            setLogoHovered(hovered)
          }}
        />
        {/* 全屏菜单 */}
        {renderDropdown(logoHovered)}
      </div>
      {/* 滚动后的顶部固定导航 */}
      <nav
        className={classNames(styles.nav, {
          [styles.show]: visible && !logoHovered,
        })}
      >
        <CenterNav />
      </nav>
    </>
  )
}

const MobileNavMenu = ({ inSeries, onSeriesChange, onLinkClick }) => {
  const data = useStaticQuery(query)
  const series = data.allSeriesJson?.edges?.map((x) => x.node)
  const collections = parseCollections(data.allCollectionsJson)

  const collectionsInSeries = collections.filter((x) => x.series === inSeries)

  const renderMain = () => {
    if (collectionsInSeries.length === 0) {
      return (
        <>
          <div className={styles.mobileNavMenuItem}>
            <h3>
              <Link to="/archive">ARCHIVE</Link>
            </h3>
            <ul className={styles.mobileNavMenuSubList}>
              {series.map((s) => {
                return (
                  <li key={s.id}>
                    <Clickable
                      onClick={() => {
                        onSeriesChange(s.title)
                      }}
                    >
                      {s.title}
                    </Clickable>
                  </li>
                )
              })}
            </ul>
          </div>

          <div className={styles.mobileNavMenuItem}>
            <h3>
              <Link to="/news">NEWS</Link>
            </h3>
          </div>
          <div className={styles.mobileNavMenuItem}>
            <h3>
              <Link to="/about">关于</Link>
            </h3>
          </div>
        </>
      )
    }

    return (
      <>
        <div className={styles.mobileNavMenuItem}>
          <h3>
            <Link to={`/archive?tab=${encodeURIComponent(inSeries)}`}>
              查看全部
            </Link>
          </h3>
          <ul className={styles.mobileNavMenuSubList}>
            {collectionsInSeries.map((c) => {
              return (
                <li key={c.id}>
                  <Link to={`/collections/${c.slug}`}>{c.title}</Link>
                  {/* <Link>{c.title}</Link> */}
                </li>
              )
            })}
          </ul>
        </div>
      </>
    )
  }

  return (
    <div
      onClick={(e) => {
        onLinkClick(e)
      }}
    >
      {renderMain()}
    </div>
  )
}

const MobileNav = ({ pathname }) => {
  const [dropDown, setDropDown] = useState(false)
  const [inSeries, setInSeries] = useState(null)

  useEffect(() => {
    if (dropDown) {
      window.document.documentElement.classList.add("is_scrollDisabled")
    } else {
      window.document.documentElement.classList.remove("is_scrollDisabled")
    }
  }, [dropDown])

  return (
    <>
      <div className={styles.mobileNavPlaceholder}></div>
      <div
        className={classNames(styles.mobileNav, {
          [styles.dropDown]: dropDown,
        })}
      >
        <div className={styles.mobileNavHead}>
          <Clickable
            className={styles.mobileNavAction}
            onClick={() => {
              if (inSeries) {
                setInSeries(null)
                return
              }
              setDropDown((d) => !d)
            }}
          >
            <SIcon
              name={(() => {
                if (inSeries) {
                  return "gi_i_back"
                }
                return dropDown ? "gi_i_close" : "gi_i_menu"
              })()}
            />
          </Clickable>

          <Clickable to="/" className={styles.mobileNavLogo}>
            <SIcon name="gi_i_logo" />
          </Clickable>
        </div>
        {dropDown && (
          <>
            <div className={styles.mobileNavDropDown}>
              <MobileNavMenu
                inSeries={inSeries}
                onSeriesChange={(s) => {
                  setInSeries(s)
                }}
                onLinkClick={(e) => {
                  const t = e.target
                  if (t.tagName === "A" && t.getAttribute("href")) {
                    setInSeries(null)
                    setDropDown(false)
                  }
                }}
              />
              <div className={styles.mobileNavFoot}>
                <div className={styles.mobileNavFootIcons}>
                  <div>
                    <h3>在线购买：</h3>
                    <IconsClickable list={ONLINE_BUY} />
                  </div>
                  <div>
                    <h3>App内购买：</h3>
                    <IconsClickable list={[GCORESAPP]} />
                  </div>
                </div>
                <p>Copyright © 2009 - 2024 GAMECORES. All Rights Reserved</p>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  )
}

const Nav = ({ location, data }) => {
  const { renderItem } = useAppContext()
  return renderItem(
    () => <DesktopNav />,
    () => <MobileNav pathname={location.pathname} />
  )
}

const query = graphql`
  query {
    allCollectionsJson {
      edges {
        node {
          id
          title
          slug
          series
          cover {
            publicURL
          }
        }
      }
    }
    allSeriesJson {
      edges {
        node {
          id
          title
          desc
        }
      }
    }
  }
`

export default Nav
